export enum BadgeType {
    gray = 'gray',
    success = 'success',
    warning = 'warning',
    highWarning = 'highWarning',
    danger = 'danger',
}
